export class ConfigHelper {

    public static Version: string = '5.4.4';

    public static Projeto: string = 'Homologação';

    public static Distribuidor: string = 'Homologacao';

    public static Url: string = 'https://api.desenvolvimento.acampa.app/api/';

    public static UrlIntergracao: string = 'https://api.desenvolvimento.acampa.app/api/';

    public static UrlStorage: string = 'https://integracao.camptecnologia.com.br/';

    public static UrlCheckList: string = 'https://checklist.desenvolvimento.acampa.app/';

    public static UrlPesquisaV1: string = 'https://api-pesquisa.camptecnologia.com.br/v1/homologacao/';

    public static ApiCheckListV1: string = 'checklist/acampa/v1/';
    
    public static ApiAnexosV1: string = 'checklist_anexos/acampa/v1/';

    public static Token: string = 'a59e7487cb56a218e6113396e64261981c647603';

    public static TokenDms: string = 'f08Ae54b97c066d0ecSD256f97c0608e54b9ea26d0e54a7RRea2e135';

    public static TokenStorage: string = 'd76e45028a10cfba523b17118f99e2e3';

    public static TokenChecklist: string = '088eceae0ebef44e9b39b83bf1df285f2fd27c9550fc9b319b8df8b3bd5ef25234780156$1$0IM3sqIV$4kfgzIMhpmIXOAgdwDB5W0';

    public static TokenPesquisa: string = 'd76e45028a10cfba523b17118f99e2e3';
    
    public static OneSignalAppId: string = '4948c0e3-6d53-4770-9490-324bda915ac7';

    //acampa31
    public static storageKeys = {
        codConcessionaria: 'hml23_06.codConcessionaria',
        cnpj: 'hml23_06.cnpj',
        cpf: 'hml23_06.cpf',
        atualizaautomaticamente: 'hml23_06.atualizaautomaticamente',
        precoosagregados: 'hml23_06.precoosagregados',
        concessionaria: 'hml23_06.concessionaria',
        cardapios1: 'hml23_06.cardapios1',
        cardapios2: 'hml23_06.cardapios2',
        marcamodelo: 'hml23_06.marcamodelo',
        checklistEntrada: 'hml23_06.checklistEntrada',
        checklistMecanico: 'hml23_06.checklistMecanico',
        checklistSaida: 'hml23_06.checklistSaida',
        checklistOrcamento: 'hml23_06.checklistOrcamento',
        checklistOficina: 'hml23_06.checklistOficina',
        checklistInspecao: 'hml23_06.checklistInspecao',
        checklistExtra: 'hml23_06.checklistExtra',
        cameraAberta: 'hml23_06.cameraAberta',
        ultimaDataLimpaCache: 'hml23_06.ultimaDataLimpaCache',
        tiposAnexos: 'hml23_06.tiposAnexos',
        dataNotificacao: 'hml23_06.dataNotificacao',
    }

    public static storageKeysSessions = {
        concessionariasAcesso: 'hml23_06.concessionariasAcesso',
        concessionariasStorage: 'hml23_06.concessionariasStorage',
        imagensCardapio: 'hml23_06.imagensCardapio'
    }
}


// WEBPACK FOOTER //
// ./src/app/helpers/configHelper.ts